import React from 'react';
import { Navigate } from 'react-router';
import { useAuth } from './AuthContext';
import LoadingSpinner from './components/shared/LoadingSpinner';

const PublicOnlyRoute = ({ children }) => {
  const { isAuthenticated, loading, onboardingComplete, onboardingStep } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (isAuthenticated) {
    if (onboardingComplete) {
      return <Navigate to="/dashboard" replace />;
    }

    return <Navigate to={`/onboarding?step=${onboardingStep || 1}`} replace />;
  }

  return children;
};

export default PublicOnlyRoute;
